<template>
    <div class="pop-up-container" v-show="open">
        <div class="content-container">
            <div class="content-wrapper">
                <div class="header">
                    <label v-if="title">{{ title }}</label>
                    <button class="button passive" @click="handleCancel">
                        <img src="@img/xmark-solid.svg"/>
                    </button>
                </div>

                <div class="content">
                    <slot>CONTENT</slot>
                </div>

                <slot name="actions">
                    <div class="actions">
                        <button class="button active" @click="handleSubmit">
                            <label>{{ submitLabel }}</label>
                        </button>
                        <button v-if="!disableCancel" class="button passive" @click="handleCancel">
                            <label>{{ cancelLabel }}</label>
                        </button>
                    </div>
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
const EMIT_UPDATE_MODEL_VALUE = 'update:modelValue'
const EMIT_CLOSE = 'close'

export default {
    name: 'pop-up',
    emits: [ EMIT_UPDATE_MODEL_VALUE, EMIT_CLOSE ],
    props: {
        open: {
            type: Boolean,
            required: true,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        submitLabel: {
            type: String,
            default: 'Submit'
        },
        cancelLabel: {
            type: String,
            default: 'Cancel'
        },
        disableCancel: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        handleSubmit() {
            this.$emit(EMIT_CLOSE, true)
        },
        handleCancel() {
            this.$emit(EMIT_CLOSE, false)
        }
    }

}
</script>

<style lang="scss" scoped>
.pop-up-container {
    z-index: 1000;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #000000aa;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;

    .content-wrapper {
        background: #fff;
        border-radius: 8px;
        padding: 16px;

        > .header {
            width: 100%;
            display: flex;
            align-items: center;
            height: 30px;

            > label {
                font-size: 1.2em;
                font-weight: bold;
            }

            > button {
                height: 100%;
                margin-left: auto;
                display: flex;
                justify-content: cemter;
                align-items: center;

                > img {
                    height: 100%;
                }
            }
        }

        > .content {
            margin-top: 20px;
        }

        > .actions {
            display: flex;
            justify-content: flex-end;
            margin-top: 20px;

            > button {
                margin-left: 8px;
            }
        }
    }
}
</style>